/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Typography, useTheme, Button, Tooltip } from "@material-ui/core";
import { withNamespaces } from "react-i18next";

import { toFixed } from "../../../constants/constants";
import bigInt from "big-integer";
import { tokens } from "../../../constants";

import GlobalStore from "../../../stores";
import { _checkAllowance, _checkApproval } from "../../../stores/private";
import config from "../../../configure/config";
import { getPoolType } from "../../pools/components/Status";
import Spinner from "../../stake/components/Spinner";

import { ReactComponent as ThumbUpSvg } from "../../../assets/thumb-up.svg";
import { ReactComponent as ThumbDownSvg } from "../../../assets/thumb-down-red.svg";
import WarningIcon from "../../../assets/warning.svg";
import moment from "moment";
import { api } from "../../stake/api";

const emitter = GlobalStore.emitter;
const Store = GlobalStore.store;
const dispatcher = GlobalStore.dispatcher;

const styles = (theme) => ({
  poolInvestCard: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "25px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "50px",
    },
  },
  poolTitle: {
    color: theme?.colors?.presale?.cardTitle,
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "8px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "16px",
    },
  },
  poolInformationContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
  },
  poolTokenInfo: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    gap: "30px",
    [theme.breakpoints.up("sm")]: {
      gap: "24px",
    },
    [theme.breakpoints.up("md")]: {
      gap: "28px",
    },

    [theme.breakpoints.up("md")]: {
      justifyContent: "space-between",
    },
  },
  lockLiqContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  voteHeading: {
    color: theme?.colors?.presale?.cardText,
    fontWeight: "normal",
    lineHeight: "normal",
    marginBottom: "0px",

    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  votesContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",

    marginBottom: "4px",

    [theme.breakpoints.up("sm")]: {
      marginBottom: "8px",
    },
  },
  voteDirIcon: {
    width: "20px",
    height: "15px",

    [theme.breakpoints.down("sm")]: {
      width: "15px",
      height: "12px",
    },

    "& > path": {
      fill: theme?.colors?.presale?.cardTitleTertiary + "!important",
    },
  },
  voteNoContainer: {
    display: "flex",
    backgroundColor: theme?.colors.poolCard?.statusBarFilled["RED"],
    borderRadius: "24px",
    padding: "6px 20px",
    height: "29px",
    color: theme?.colors?.presale?.cardTitleTertiary,
    textAlign: "left",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0px",
    fontWeight: "600",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      height: "26px",
      padding: "6px 10px",
    },
  },
  voteYesContainer: {
    display: "flex",
    backgroundColor: theme?.colors?.presale?.verifiedBg,
    borderRadius: "24px",
    padding: "6px 20px",
    height: "29px",
    color: theme?.colors?.presale?.cardTitleTertiary,
    textAlign: "left",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0px",
    fontWeight: "600",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      height: "26px",
      padding: "6px 10px",
    },
  },
  abstainedContainer: {
    display: "flex",
    backgroundColor: theme?.colors.poolCard?.statusBarFilled["YELLOW"],
    borderRadius: "24px",
    padding: "6px 20px",
    height: "29px",
    color: theme?.colors?.presale?.cardTitleTertiary,
    textAlign: "left",
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0px",
    fontWeight: "600",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      height: "26px",
      padding: "6px 10px",
    },
  },
  poolTokenInfoItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: theme?.colors?.presale?.cardBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "30px",
    padding: "20px",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "30px",
      padding: "32px",
    },

    [theme.breakpoints.up("md")]: {
      alignItems: "flex-start",
    },
  },
  infoHeading: {
    color: theme?.colors?.presale?.cardText,
    fontWeight: "normal",
    lineHeight: "normal",
    marginBottom: "4px",

    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "8px",
      fontSize: "16px",
    },
  },
  claimExtraInfo: {
    width: "100%",

    marginTop: "12px",
    [theme.breakpoints.up("md")]: {
      marginTop: "15px",
    },
  },
  claimExtraInfoText: {
    color: theme?.colors?.presale?.cardText,
    fontWeight: "normal",
    lineHeight: "normal",
    marginTop: "4px",
    marginBottom: "0px",

    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "8px",
      fontSize: "16px",
    },
  },
  infoValue: {
    color: theme?.colors?.presale?.cardTitle,
    fontSize: "18px",
    fontWeight: "600",
    [theme.breakpoints.up("sm")]: {
      fontSize: "24px",
    },
  },
  tooltip: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "200px",
    },
  },
  actionButton: {
    "&:disabled": {
      opacity: "0.7",
      color: theme?.colors?.wallet?.buttonTextSecondary,
      cursor: "not-allowed",
    },
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",

    width: "100%",

    marginTop: "12px",

    padding: "12px",
    [theme.breakpoints.up("md")]: {
      padding: "16px",
      marginTop: "15px",

      width: "200px",
    },
  },
  buttonLabel: {
    fontWeight: "normal",
    fontSize: "15px",
    lineHeight: "18px",
  },
  tokenTooltip: {
    fontWeight: "normal",
    fontSize: "15px",
    lineHeight: "18px",
  },
  warningContainerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: theme?.colors?.presale?.cardBackground,
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "30px",
    padding: "20px",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "30px",
      padding: "32px",
    },

    [theme.breakpoints.up("md")]: {
      alignItems: "flex-start",
    },
  },

  warningContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "10px 20px",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,

    borderRadius: "12px",
  },
  warningText: {
    color: theme?.colors?.poolCard?.titleSecondary,
    textAlign: "center",
    fontSize: "20px",
    lineHeight: "25px",
  },
});

const InvestCard = ({
  classes,
  poolInfo,
  onClaim,
  onVote,
  onRefund,
  onBuy,
  onLockLiq,
  account,
}) => {
  const currentTimestamp = Date.now() / 1000;
  const [isClaimAllowed, setIsClaimAllowed] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isLoadingApproval, setIsLoadingApproval] = useState(true);

  const theme = useTheme();
  const [fundingToken, setFundingToken] = useState(
    tokens[poolInfo?.fundingTokenAddress]
  );

  const [tokenUsdPrice, setTokenUsdPrice] = useState(0);

  const [voteAvailable, setVoteAvailable] = useState(
    parseFloat(
      toFixed(poolInfo?.voteAvailable, poolInfo?.fundingTokenDecimals || 18, 6)
    )
  );
  const [votedBalance, setVotedBalance] = useState(
    parseFloat(
      toFixed(poolInfo?.voteAvailable, poolInfo?.fundingTokenDecimals || 18, 6)
    )
  );
  const [voteDirection, setVoteDirection] = useState("0");

  const [voteDisabled, setVoteDisabled] = useState(
    voteAvailable === 0 ||
      votedBalance > 0 ||
      poolInfo?.openTime <= currentTimestamp
  );

  const themeType = Store.getStore("themeType");
  const factory = Store.getStore("factory");

  useEffect(() => {
    setIsClaimAllowed(
      poolInfo.presaleType === "0"
        ? poolInfo?.claimAllowed
        : poolInfo?.cakeLiquidityAdded || poolInfo?.claimAllowed
    );
  }, [currentTimestamp, poolInfo]);

  useEffect(() => {
    const checkIfApproved = async () => {
      const minApprovedAmount = bigInt(poolInfo?.maxInvestInWei)
        .multiply(bigInt(10).pow(poolInfo?.fundingTokenDecimals || 18))
        .divide(poolInfo?.tokenPriceInWei)
        .toString();

      const isAllowed = await _checkAllowance(
        Store,
        config[themeType].ERC20Abi,
        poolInfo?.fundingTokenAddress,
        account,
        minApprovedAmount,
        poolInfo?.presaleAddress
      );

      setIsApproved(isAllowed);
      setIsLoadingApproval(false);
    };

    checkIfApproved();
  }, [
    account,
    factory.factoryAddress,
    poolInfo?.minInvestInWei,
    poolInfo?.tokenPriceInWei,
    poolInfo?.fundingTokenDecimals,
    poolInfo?.fundingTokenAddress,
    themeType,
  ]);

  useEffect(() => {
    setFundingToken(tokens[poolInfo?.fundingTokenAddress]);
    setVoteAvailable(
      parseFloat(
        toFixed(
          poolInfo?.voteAvailable,
          poolInfo?.fundingTokenDecimals || 18,
          6
        )
      )
    );
    setVotedBalance(
      parseFloat(
        toFixed(
          bigInt(poolInfo?.votedBalance),
          poolInfo?.fundingTokenDecimals || 18,
          6
        )
      )
    );

    setVoteDirection(poolInfo?.voteDirection);
    setVoteDisabled(
      voteAvailable === 0 ||
        votedBalance > 0 ||
        poolInfo?.openTime <= currentTimestamp
    );
  }, [poolInfo, account, voteAvailable, votedBalance, currentTimestamp]);

  const getTokenPriceInUsd = async (tokenAddress) => {
    try {
      const url = `https://api.dexscreener.com/latest/dex/tokens/${tokenAddress}`;
      const res = await api.get(url);

      const lpPairs = res.data.pairs;

      return lpPairs.length > 0 ? Number(lpPairs[0].priceUsd) : 0;
    } catch (e) {
      console.error("GET_TOKEN_PRICE_IN_USD", e);
      return 0;
    }
  };

  useEffect(() => {
    const loadTokenPrice = async () => {
      const tokenPriceInUsd = await getTokenPriceInUsd(poolInfo.tokenAddress);

      setTokenUsdPrice(tokenPriceInUsd);
    };

    loadTokenPrice();
  }, [poolInfo]);

  const DirectionLabel = () => {
    // 0 Abstained, 1 Yes, 2 No
    if (voteDirection === "2") {
      return (
        <div className={classes.voteNoContainer}>
          <ThumbDownSvg className={classes.voteDirIcon} />
          &nbsp;&nbsp;Voted No
        </div>
      );
    }

    if (voteDirection === "1") {
      return (
        <div className={classes.voteYesContainer}>
          <ThumbUpSvg className={classes.voteDirIcon} />
          &nbsp;&nbsp;Voted Yes
        </div>
      );
    }

    return (
      <div className={classes.abstainedContainer}>
        <img
          src={WarningIcon}
          alt="CheckMark"
          className={classes.voteDirIcon}
        />
        &nbsp;&nbsp;Abstained
      </div>
    );
  };

  const tokenInvestPart = (
    heading,
    value,
    buttonText,
    clickHandler,
    disabled = false,
    tooltip = false,
    tooltipText = null,
    extraInfo = <div />
  ) => {
    return (
      <div className={classes.poolTokenInfoItem}>
        {heading}
        <Typography variant="h2" className={classes.infoValue}>
          {value}
        </Typography>
        {tooltip && disabled && (
          <Tooltip className={classes.tooltip} title={tooltipText}>
            <span>
              <Button
                classes={{
                  root: classes.actionButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  if (clickHandler) {
                    clickHandler();
                  }
                }}
                disabled={disabled}
              >
                {buttonText}
              </Button>
            </span>
          </Tooltip>
        )}
        {tooltip && !disabled && (
          <Tooltip className={classes.tooltip} title={tooltipText}>
            <Button
              classes={{
                root: classes.actionButton,
                label: classes.buttonLabel,
              }}
              onClick={() => {
                if (clickHandler) {
                  clickHandler();
                }
              }}
              disabled={disabled}
            >
              {buttonText}
            </Button>
          </Tooltip>
        )}
        {!tooltip && (
          <Button
            classes={{
              root: classes.actionButton,
              label: classes.buttonLabel,
            }}
            onClick={() => {
              if (clickHandler) {
                clickHandler();
              }
            }}
            disabled={disabled}
          >
            {buttonText}
          </Button>
        )}
        {extraInfo}
      </div>
    );
  };

  const appovePresale = async () => {
    try {
      const approveMaxAmount = bigInt("9999999999")
        .multiply(bigInt(10).pow(poolInfo?.fundingTokenDecimals || 18))
        .toString();
      // const approveMaxAmount = bigInt(poolInfo.hardCapInWei)
      //   .multiply(bigInt(10).pow(poolInfo?.fundingTokenDecimals || 18))
      //   .divide(poolInfo.tokenPriceInWei)
      //   .toString();

      await _checkApproval(
        Store,
        dispatcher,
        emitter,
        config[themeType].ERC20Abi,
        poolInfo?.fundingTokenAddress,
        account,
        approveMaxAmount,
        poolInfo?.presaleAddress
      );

      const minApprovedAmount = bigInt(poolInfo.maxInvestInWei)
        .multiply(bigInt(10).pow(poolInfo?.fundingTokenDecimals || 18))
        .divide(poolInfo.tokenPriceInWei)
        .toString();

      const isAllowed = await _checkAllowance(
        Store,
        config[themeType].ERC20Abi,
        poolInfo?.fundingTokenAddress,
        account,
        minApprovedAmount,
        poolInfo?.presaleAddress
      );

      setIsApproved(isAllowed);
    } catch (err) {
      console.log("APPROVE_ERROR", err);
    }
  };

  return (
    <>
      <Typography variant="h3" className={classes.poolTitle}>
        Your Investment
      </Typography>

      <div className={classes.poolInvestCard}>
        {account && account.address && (
          <div className={classes.poolInformationContainer}>
            <div className={classes.poolTokenInfo}>
              {poolInfo?.presaleType !== "2" &&
                !poolInfo?.certified &&
                tokenInvestPart(
                  <div className={classes.votesContainer}>
                    <Typography variant="h5" className={classes.voteHeading}>
                      Vote
                    </Typography>
                    <DirectionLabel />
                  </div>,
                  voteAvailable + " " + (poolInfo?.stakingTokenName || "BUIDL"),
                  "Vote",
                  onVote,
                  voteDisabled
                )}

              {poolInfo?.certified && (
                <div className={classes.poolTokenInfoItem}>
                  <Typography variant="h5" className={classes.infoHeading}>
                    Your Current Stake
                  </Typography>
                  <Typography variant="h2" className={classes.infoValue}>
                    {toFixed(
                      poolInfo?.stakedBalance,
                      poolInfo?.tokenDecimals || 18,
                      6
                    )}
                  </Typography>
                </div>
              )}

              {isLoadingApproval ? (
                <div
                  className={classes.poolTokenInfoItem}
                  style={{
                    height: "185px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner strokeSize="5px" width="42px" height="42px" />
                </div>
              ) : isApproved ? (
                tokenInvestPart(
                  <Typography variant="h5" className={classes.infoHeading}>
                    Buy Tokens
                  </Typography>,
                  "1 Token = " +
                    (toFixed(
                      bigInt(poolInfo?.tokenPriceInWei),
                      poolInfo?.fundingTokenDecimals || 18,
                      6
                    ) || 0) +
                    " " +
                    fundingToken?.label,
                  "Buy",
                  onBuy,
                  poolInfo?.openTime - 3600 > currentTimestamp ||
                    getPoolType(poolInfo, theme)[0] !== "ONGOING",

                  poolInfo?.openTime - 3600 > currentTimestamp,
                  poolInfo?.openTime - 3600 > currentTimestamp
                    ? "Presale is not opened yet."
                    : null
                )
              ) : (
                tokenInvestPart(
                  <Typography variant="h5" className={classes.infoHeading}>
                    Approve Pool to Buy
                  </Typography>,
                  "",
                  "Approve",
                  appovePresale
                )
              )}
              {tokenInvestPart(
                <Typography variant="h5" className={classes.infoHeading}>
                  Unclaimed Tokens
                </Typography>,
                `${parseFloat(poolInfo?.tokenAmount || 0).toFixed(6)} ${
                  poolInfo?.tokenSymbol
                } ($${((poolInfo?.tokenAmount || 0) * tokenUsdPrice).toFixed(
                  2
                )} USD)`,
                "Claim Tokens",
                onClaim,
                poolInfo?.tokenAmount === 0 || !isClaimAllowed,
                false,
                null,
                <div className={classes.claimExtraInfo}>
                  {poolInfo?.lastClaimed &&
                    poolInfo?.lastClaimed !== 0 &&
                    poolInfo?.lastClaimed !== "0" && (
                      <Typography
                        variant="h5"
                        className={classes.claimExtraInfoText}
                      >
                        <strong>Last Claimed:</strong>{" "}
                        {moment
                          .unix(poolInfo?.lastClaimed)
                          // .tz("Etc/GMT")
                          .format("MMMM DD, YYYY HH:mm A z")}
                      </Typography>
                    )}
                  {parseFloat(poolInfo?.tokenAmount || 0) !== 0 &&
                    poolInfo?.nextClaimTime &&
                    poolInfo?.nextClaimTime !== 0 &&
                    poolInfo?.nextClaimTime !== "0" && (
                      <Typography
                        variant="h5"
                        className={classes.claimExtraInfoText}
                      >
                        <strong>Next Claim:</strong>{" "}
                        {moment
                          .unix(poolInfo?.nextClaimTime)
                          // .tz("Etc/GMT")
                          .format("MMMM DD, YYYY HH:mm A z")}
                      </Typography>
                    )}
                  {poolInfo?.releaseAmount !== undefined && (
                    <Typography
                      variant="h5"
                      className={classes.claimExtraInfoText}
                    >
                      <strong>Accumulated Since Last Claim:</strong>{" "}
                      {poolInfo?.releaseAmount?.toFixed(6)}{" "}
                      {poolInfo?.tokenSymbol} ($
                      {(poolInfo?.releaseAmount * tokenUsdPrice)?.toFixed(
                        2
                      )}{" "}
                      USD)
                    </Typography>
                  )}
                  {poolInfo?.totalClaimed !== undefined && (
                    <Typography
                      variant="h5"
                      className={classes.claimExtraInfoText}
                    >
                      <strong>Claimed YTD:</strong>{" "}
                      {(poolInfo?.totalClaimed).toFixed(6)}{" "}
                      {poolInfo?.tokenSymbol} ($
                      {(poolInfo?.totalClaimed * tokenUsdPrice).toFixed(2)} USD)
                    </Typography>
                  )}
                </div>
              )}

              {tokenInvestPart(
                <Typography variant="h5" className={classes.infoHeading}>
                  Your {fundingToken?.label} Investment
                </Typography>,
                (toFixed(
                  bigInt(poolInfo?.accountInvestment),
                  poolInfo?.fundingTokenDecimals || 18,
                  6
                ) || 0) +
                  " " +
                  fundingToken?.label,
                "Get Refund",
                onRefund,
                !poolInfo?.presaleCancelled ||
                  Number(parseFloat(poolInfo?.tokenAmount || 0).toFixed(6)) <=
                    0,
                false,
                null
              )}
            </div>
          </div>
        )}
        {(!account || !account.address) && (
          <div className={classes.warningContainerWrapper}>
            <div className={classes.warningContainer}>
              <Typography variant="h4" className={classes.warningText}>
                Please connect your wallet and set network to{" "}
                {theme?.chain || "Base"}.
              </Typography>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(InvestCard)));
